import { render } from "./CurrentTags.vue?vue&type=template&id=3ccc0d04&scoped=true"
import script from "./CurrentTags.vue?vue&type=script&lang=js"
export * from "./CurrentTags.vue?vue&type=script&lang=js"

import "./CurrentTags.vue?vue&type=style&index=0&id=3ccc0d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccc0d04"]])

export default __exports__